import api from "../../config/axios";

import axios from "axios";
import FormData from "form-data";

export const addCompanyDetails = async (companyName, aboutCompany) => {
  try {
    const response = await api.post(`/add_companies`, {
      company_name: companyName,
      about_company: aboutCompany,
    });
    return response.data;
  } catch (error) {
    error.message = error.response && error.response.data.message;
    throw error;
  }
};

export const getRecruiterInfo = async (recruiterId) => {
  try {
    const response = await api.post(`/recruiter_info`, {
      recruiter_id: recruiterId,
    });
    return response.data;
  } catch (error) {
    error.message = error.response && error.response.data.message;
    throw error;
  }
};

export const fetchTestInfo = async (testId) => {
  try {
    const response = await api.post(`/get_test_creation`, {
      test_id: 881,
    });
    return response.data;
  } catch (error) {
    error.message = error.response && error.response.data.message;
    throw error;
  }
};

export const getCompanyInfo = async (companyId) => {
  try {
    const response = await api.post(`/company_info`, {
      company_id: companyId,
    });
    return response.data;
  } catch (error) {
    error.message = error.response && error.response.data.message;
    throw error;
  }
};

export const updateRecruiterInfo = async (
  recruiterId,
  recruiterName,
  recruiterMobile,
  recruiterEmail,
  recruiterContent,
  companyId,
  companyType
) => {
  try {
    const payload = {
      recruiter_id: recruiterId,
      recruiter_name: recruiterName,
      email: recruiterEmail,
      mobile: recruiterMobile,
      about_recruiter: recruiterContent,
      company_id: companyId,
      company_type: companyType
    };

    // Log the payload received by the API
    console.log('Payload received by updateRecruiterInfo API:', payload);

    const response = await api.post(`/update_recruiter_profile`, payload);
    return response.data;
  } catch (error) {
    error.message = error.response && error.response.data.message;
    throw error;
  }
};


export const getJobDetails = async (jobId) => {
  try {
    const response = await api.post(`/get_job_details`, {
      job_id: jobId,
    });
    return response.data;
  } catch (error) {
    error.message = error.response && error.response.data.message;
    throw error;
  }
};

export const getCandidates = async (
  skills,
  experience,
  availability,
  location,
  searchType
) => {
  try {
    const types = (searchType || "").split(",").map((t) => t.trim());
    const response = await api.post(`/v1/get_candidates`, {
      skills: types.includes("skills") ? skills : "",
      experience: types.includes("experience") ? experience : "",
      search_type: searchType,
      availability: types.includes("availability") ? availability : "",
      location: types.includes("location") ? location : "",
    });
    return response.data;
  } catch (error) {
    error.message = error.response && error.response.data.message;
    throw error;
  }
};

export const searchResumesByKeyword = async (keyword) => {
  try {
    const response = await api.post("/search_resumes", {
      keywords: keyword,
    });
    return response.data;
  } catch (error) {
    if (error.response) {
      console.error("Request failed with status code:", error.response.status);
    } else if (error.request) {
      console.error("Request made but no response received:", error.request);
    } else {
      console.error("Error setting up the request:", error.message);
    }
    throw error;
  }
};

// Updated getJobs function to handle job_type parameter
export const getJobs = async (skills, experience, location, search_type, job_type = null) => {
  try {
    // Build the payload object
    const payload = {
      search_type: search_type,
      experience: experience,
      skills: Array.isArray(skills) ? skills : [skills],
      location: location
    };

    // ALWAYS include job_type in payload (either the selected value or null)
    payload.job_type = job_type;

    console.log("API Payload being sent:", payload);

    const response = await api.post('/v1/get_jobs', payload);
    
    console.log("API Response:", response.data);
    return response.data;
    
  } catch (error) {
    console.error("Error in getJobs API:", error);
    throw error;
  }
};

export const checkCandidateStatus = async (jobId, userId) => {
  try {
    const response = await api.post(`/check_candidate_status`, {
      job_id: jobId,
      user_id: userId,
    });
    return response.data;
  } catch (error) {
    error.message = error.response && error.response.data.message;
    throw error;
  }
};

export const addJob = async (
  recruiterId,
  companyId,
  jobRole,
  jobSkills,
  jobExperience,
  jobMaxExperience,    // NEW parameter
  jobDescription,
  jobLocation,
  jobAvailability,
  jobType,
  jobSalary,          // NEW parameter
  jobMaxSalary,       // NEW parameter
  publicUrl           // ADD THIS NEW parameter
) => {
  try {
    if (jobLocation === "" || jobLocation == null) return false;
    const response = await api.post(`/set_job_listing`, {
      company_id: companyId,
      recruiter_id: recruiterId,
      job_role: jobRole,
      skills: jobSkills,
      experience: jobExperience,
      max_experience: jobMaxExperience,    // NEW field
      job_description: jobDescription,
      location: jobLocation,
      invite_candidate_count: 0,
      salary: jobSalary,                   // NEW field
      max_salary: jobMaxSalary,            // NEW field
      availability: jobAvailability,
      job_type: jobType,
      public_url: publicUrl,               // ADD THIS NEW field
    });
    return response.data;
  } catch (error) {
    error.message = error.response && error.response.data.message;
    throw error;
  }
};

export const getRecruiterJobs = async (companyId) => {
  try {
    console.log("getRecruiterJobs received companyId:", companyId); // Debug log

    if (!companyId) {
      throw new Error("Company ID is required");
    }

    const response = await api.post(`/get_recruiter_job_details`, {
      company_id: companyId,
    });
    console.log("API Response:", response.data); // Debug log
    return response.data;
  } catch (error) {
    console.error("API Error:", error); // Debug log
    error.message = error.response?.data?.message || error.message;
    throw error;
  }
};

// Generate assessment questions from a job description
export const generateQuestionsFromJd = async (payload) => {
  try {
    const response = await api.post(`/generate_questions_from_jd`, payload);
    return response.data;
  } catch (error) {
    error.message =
      error.response?.data?.message ||
      error.response?.data?.error ||
      error.message;
    throw error;
  }
};

export const deleteJobApi = async (jobId) => {
  try {
    const response = await api.post(`/delete_job_api`, {
      job_id: jobId,
    });
    return response.data;
  } catch (error) {
    // Backend often returns `{ error: "..." }` (see Postman/screenshot).
    error.message =
      error.response?.data?.error ||
      error.response?.data?.message ||
      error.message;
    throw error;
  }
};

export const uploadJobs = async (formData) => {
  try {
    const response = await api.post(`/set_excel_job_listing`, formData, {
      headers: {
        "Content-Type": "multipart/form-data",
      },
    });
    return response.data;
  } catch (error) {
    error.message =
      error.response?.data?.error ||
      error.response?.data?.message ||
      error.message;
    throw error;
  }
};

/**
 * Preview job file (e.g. PDF) - returns parsed job data to fill the form.
 * Payload: form-data with key "file".
 */
export const previewJobFile = async (formData) => {
  try {
    const response = await api.post(`/preview_job_file`, formData, {
      headers: {
        "Content-Type": "multipart/form-data",
      },
    });
    return response.data;
  } catch (error) {
    error.message = error.response && error.response.data?.message || error.message;
    throw error;
  }
};

export const setTest = async (testSettings) => {
  const {
    test_name,
    job_id,
    difficulty,
    proficiency,
    total_mcq_question,
    total_mri_question,
    total_fill_blanks_question,
    total_descriptive_question,
    total_coding_question,
    total_time,
    topics,
    easy_mcq_count,
    medium_mcq_count,
    hard_mcq_count,
    easy_mri_count,
    medium_mri_count,
    hard_mri_count,
    easy_fill_blanks_count,
    medium_fill_blanks_count,
    hard_fill_blanks_count,
    easy_descriptive_count,
    medium_descriptive_count,
    hard_descriptive_count,
    easy_coding_count,
    medium_coding_count,
    hard_coding_count,
    recruiter_id,
    company_id,
    test_subscription_type,
    test_settings_created,
    assessment,
    token_expiration_date,
  } = testSettings;
  try {
    const response = await api.post(`/set_test`, {
      test_name,
      job_id,
      difficulty,
      proficiency,
      total_mcq_question,
      total_mri_question,
      total_fill_blanks_question,
      total_descriptive_question,
      total_coding_question,
      total_time,
      topics,
      easy_mcq_count,
      medium_mcq_count,
      hard_mcq_count,
      easy_mri_count,
      medium_mri_count,
      hard_mri_count,
      easy_fill_blanks_count,
      medium_fill_blanks_count,
      hard_fill_blanks_count,
      easy_descriptive_count,
      medium_descriptive_count,
      hard_descriptive_count,
      easy_coding_count,
      medium_coding_count,
      hard_coding_count,
      recruiter_id,
      company_id,
      test_subscription_type,
      test_settings_created,
      assessment,
      token_expiration_date,
    });
    return response.data;
  } catch (error) {
    error.message = error.response && error.response.data.message;
    throw error;
  }
};

export const getTestId = async (jobId) => {
  try {
    let testId = await api.post(`/get_tests_by_job_id`, {
      job_id: jobId,
    });
    testId = testId.data.test_info;
    return testId;
  } catch (err) {
    console.error(err);
  }
};
export const getTest = async (jobId) => {
  try {
    let testId = await api.post(`/get_tests_by_job_id`, {
      job_id: jobId,
    });
    testId = testId.data.test_id;
    const response = await api.post(`/get_test`, {
      test_id: testId[0],
    });
    return response.data;
  } catch (error) {
    error.message = error.response && error.response.data.message;
    throw error;
  }
};

export const getTestByAssesment = async (jobId, assessment) => {
  try {
    let testId = await api.post(`/get_tests_by_job_id`, {
      job_id: jobId,
    });

    let testAvalable = testId.data.test_info.filter(
      (test) => test.assessment == assessment
    );

    if (testAvalable.length > 0) {
      const response = await api.post(`/get_test`, {
        test_id: testAvalable[0].test_id,
      });

      return response.data;
    } else {
      return null;
    }
  } catch (error) {
    error.message = error.response && error.response.data.message;
    throw error;
  }
};

//save question sheet

export const getSavequestionsheet = async (csv_file, sheet_name) => {
  try {
    const response = await api.post(`/save_question_sheet`, {
      csv_file: csv_file,
      sheet_name: sheet_name,
    });
    return response.data;
  } catch (error) {
    error.message = error.response && error.response.data.message;
    throw error;
  }
};

// set short List Candiates
export const setShortList = async (jobId, userId, testId) => {
  try {
    const response = await api.post(`/set_shortlist_candidate`, {
      job_id: jobId,
      user_id: userId,
      test_id: testId,
    });
    return response.data;
  } catch (error) {
    error.message = error.response && error.response.data.message;
    throw error;
  }
};

// get shortlist candiates
export const getShortlistData = async (jobId, ids) => {
  try {
    const response = await api.post(`/get_shortlist_candidate`, {
      job_id: jobId,
      test_ids: ids,
    });
    return response.data;
  } catch (error) {
    error.message = error.response && error.response.data.message;
    throw error;
  }
};

// set shortlist candiates
export const setShortListData = async (shortlistData) => {
  try {
    const response = await api.post(`/set_shortlist_candidate`, shortlistData, {
      headers: { "Content-Type": "text/plain" },
    });
    return response.data;
  } catch (error) {
    error.message = error.response && error.response.data.message;
    throw error;
  }
};

// shorttlist cadidates Count
export const getShortlistCandidateCount = async (jobId) => {
  try {
    const response = await api.post(`/get_shortlist_candidate_count`, {
      job_id: jobId,
      // user_id:userId,
    });
    return response.data;
  } catch (error) {
    error.message = error.response && error.response.data.message;
    throw error;
  }
};

{
  /* new changes start */
}
// shortlist by company count (New Changes)
export const getShortlistCompanyCount = async (companyId) => {
  try {
    const response = await api.post(
      `/get_shortlist_candidate_by_company_count`,
      {
        company_id: companyId,
        // user_id:userId,
      }
    );
    return response.data;
  } catch (error) {
    error.message = error.response && error.response.data.message;
    throw error;
  }
};
{
  /* new changes End */
}

// shortlisted candidates count grouped by job for a company (single call)
export const getShortlistCountPerJob = async (companyId) => {
  try {
    const response = await api.post(`/shortlist_count_per_job`, {
      company_id: companyId,
    });
    return response.data;
  } catch (error) {
    error.message = error.response && error.response.data.message;
    throw error;
  }
};

// completed test count grouped by job for a company
export const getJobWiseCompletedTestCount = async (companyId) => {
  try {
    const response = await api.post(`/job_wise_completed_test_count`, {
      company_id: companyId,
    });
    return response.data;
  } catch (error) {
    error.message = error.response && error.response.data.message;
    throw error;
  }
};

// offer letter count grouped by job for a company (single call)
export const getOfferLetterCountPerJob = async (companyId) => {
  try {
    const response = await api.post(`/offer_letter_count_per_job`, {
      company_id: companyId,
    });
    return response.data;
  } catch (error) {
    error.message = error.response && error.response.data.message;
    throw error;
  }
};

// total completed test count for a company
export const getCompanyCompletedTestCount = async (companyId) => {
  try {
    const response = await api.post(`/company_completed_test_count`, {
      company_id: companyId,
    });
    return response.data;
  } catch (error) {
    error.message = error.response && error.response.data.message;
    throw error;
  }
};

// offer letter count for a company (total + job wise)
export const getCountOfferLetters = async (companyId) => {
  try {
    const response = await api.post(`/offer_letter_count_per_job`, {
      company_id: companyId,
    });
    return response.data;
  } catch (error) {
    error.message = error.response && error.response.data.message;
    throw error;
  }
};

// company logo uploader
export const uploadcompanyLogo = async (formData) => {
  try {
    const response = await api.post(`/save_company_logo`, formData, {
      headers: {
        "Content-Type": "multipart/form-data",
      },
    });
    return response.data;
  } catch (error) {
    error.message = error.response && error.response.data.message;
    throw error;
  }
};

// get the company logo
export const getCompanyLogo = async (testId) => {
  try {
    const response = await api.post(
      `/get_company_logo`,
      {
        test_id: testId  // Use test_id in the payload
      },
      {
        responseType: "blob",
      }
    );
    return response.data;
  } catch (error) {
    error.message = error.response && error.response.data.message;
    throw error;
  }
};

// Fetch a company logo (blob) by its company id (used for white labelling)
export const getCompanyLogoByCompanyId = async (companyId) => {
  try {
    const response = await api.post(
      `/get_company_logo_by_company_id`,
      {
        company_id: companyId,
      },
      {
        responseType: "blob",
      }
    );
    return response.data;
  } catch (error) {
    error.message = error.response && error.response.data.message;
    throw error;
  }
};

{
  /* new changes start */
}
// { company info details}
export const getCompanyInfodetailsall = async (companyId) => {
  try {
    const response = await api.post(`/company_info_all`, {
      company_id: companyId,
    });
    return response.data;
  } catch (error) {
    error.message = error.response && error.response.data.message;
    throw error;
  }
};
{
  /* new changes End */
}

{
  /* new changes for read company details */
}
export const readcompanydetails = async (formData) => {
  try {
    const response = await api.post(`/read_company_details`, formData, {
      headers: {
        "Content-Type": "multipart/form-data",
      },
    });
    return response.data;
  } catch (error) {
    error.message = error.response && error.response.data.message;
    throw error;
  }
};
{
  /* new changes End */
}

{
  /* new changes for image company details */
}
export const imagecompanydetails = async (formData) => {
  try {
    const response = await api.post(`/image_company_details`, formData, {
      headers: {
        "Content-Type": "multipart/form-data",
      },
    });
    return response.data;
  } catch (error) {
    error.message = error.response && error.response.data.message;
    throw error;
  }
};
{
  /* new changes End */
}

{
  /* New Changes for delete test [Start] */
}
export const deleteTest = async (testId) => {
  try {
    const response = await api.post(`/delete_test`, {
      test_id: testId,
    });
    return response.data;
  } catch (error) {
    error.message = error.response && error.response.data.message;
    throw error;
  }
};
{
  /* New Changes for delete [End] */
}

{
  /* New Changes for get test creation [Start] */
}
export const getTestCreation = async (testId) => {
  try {
    const response = await api.post(`/get_test_creation`, {
      test_id: testId,
    });
    return response.data;
  } catch (error) {
    error.message = error.response && error.response.data.message;
    throw error;
  }
};
{
  /* New Changes for get test creation [End] */
}

{
  /* New Changes for create or update test [Start] */
}
export const createOrUpdateTest = async (testCreation) => {
  const {
    test_name,
    difficulty,
    proficiency,
    total_mcq_question,
    total_mri_question,
    total_fill_blanks_question,
    total_descriptive_question,
    total_coding_question,
    total_time,
    topics,
    easy_mcq_count,
    medium_mcq_count,
    hard_mcq_count,
    easy_mri_count,
    medium_mri_count,
    hard_mri_count,
    easy_fill_blanks_count,
    medium_fill_blanks_count,
    hard_fill_blanks_count,
    easy_descriptive_count,
    medium_descriptive_count,
    hard_descriptive_count,
    easy_coding_count,
    medium_coding_count,
    hard_coding_count,
    recruiter_id,
    company_id,
    token,
    image_folder_name,
    test_subscription_type,
    test_settings_created,
    token_expiration_date,
    skills,
    test_id,
    campus,
    public_test, // Add this line
    Certificate_assesment,
  } = testCreation;

  try {
    const response = await api.post(`/create_or_update_test`, {
      test_name,
      difficulty,
      proficiency,
      total_mcq_question,
      total_mri_question,
      total_fill_blanks_question,
      total_descriptive_question,
      total_coding_question,
      total_time,
      topics,
      easy_mcq_count,
      medium_mcq_count,
      hard_mcq_count,
      easy_mri_count,
      medium_mri_count,
      hard_mri_count,
      easy_fill_blanks_count,
      medium_fill_blanks_count,
      hard_fill_blanks_count,
      easy_descriptive_count,
      medium_descriptive_count,
      hard_descriptive_count,
      easy_coding_count,
      medium_coding_count,
      hard_coding_count,
      recruiter_id,
      company_id,
      token,
      image_folder_name,
      test_subscription_type,
      test_settings_created,
      token_expiration_date,
      skills,
      test_id,
      campus,
      public_test, // Add this line
      Certificate_assesment,
    });

    const responseOne = await api.post(`/get_test_creation`, {
      test_id: response.data.test_id,
    });

    console.log("Create/Update Test Response:", response.data);
    console.log("Get Test Creation Response:", responseOne.data);

    return responseOne.data;
  } catch (error) {
    console.error("Error in createOrUpdateTest:", error);
    error.message = error.response && error.response.data.message;
    throw error;
  }
};

export const sendAssessmentInfoEmail = async ({
  candidateEmails = [],
  companyId,
  recruiterId,
  testId,
  publicUrl,
}) => {
  try {
    const response = await api.post(`/send_assessment_info_email`, {
      candidate_emails: candidateEmails,
      company_id: companyId,
      recruiter_id: recruiterId,
      test_id: testId,
      public_url: publicUrl,
    });

    return response.data;
  } catch (error) {
    error.message =
      error.response?.data?.message ||
      "Failed to send public assessment invite emails.";
    throw error;
  }
};

export const getRecruiterTestInfo = async (recruiterId) => {
  try {
    const response = await api.post(`/get_recruiter_test_details`, {
      recruiter_id: recruiterId,
    });
    return response.data;
  } catch (error) {
    error.message = error.response && error.response.data.message;
    throw error;
  }
};

export const getCompanyTestInfo = async (companyId) => {
  try {
    const response = await api.post(`/get_company_test_details`, {
      company_id: companyId,
    });
    return response.data;
  } catch (error) {
    error.message = error.response && error.response.data.message;
    throw error;
  }
};

// test id
export const getMailTestOne = async (testId) => {
  const response = await api.post(`/get_test_creation`, {
    test_id: testId,
  });

  return response;
};

// export const sendTest = async (testId, emailId) => {
//   try {
//     const response = await api.post(`/send_test`, {
//       email: emailId,
//       test_id: testId,
//     });
//     return response.data;
//   } catch (error) {
//     error.message = error.response && error.response.data.message;
//     throw error;
//   }
// };
{
  /* New Changes in Send Test [End] */
}

{
  /* New Changes in Send Invite [Start] */
}
export const SendInvite = async (formData) => {
  try {
    // Convert formData to x-www-form-urlencoded format
    const urlSearchParams = new URLSearchParams();
    for (const [key, value] of Object.entries(formData)) {
      urlSearchParams.append(key, value);
    }
    // Make the POST request using Axios
    const response = await api.post(
      "/send_assessment_confirmation",
      urlSearchParams.toString(),
      {
        headers: {
          "Content-Type": "application/x-www-form-urlencoded",
        },
      }
    );

    // Return the response data
    if (response.data);
  } catch (error) {
    // Handle errors
    error.message = error.response && error.response.data.message;
    throw error;
  }
};

{
  /* New Changes in Send Invite [Ends] */
}

{
  /* New Changes in Store Email [Starts] */
}
// export const StoreEmail = async (formData) => {
//   try {
//     // Modify formData properties to match backend expectations
//     const modifiedFormData = {
//       email_id: formData.email,
//       test_id: formData.testId,
//     };

//     console.log(modifiedFormData)

//     // Convert modified formData to x-www-form-urlencoded format
//     const urlSearchParams = new URLSearchParams();
//     for (const [key, value] of Object.entries(modifiedFormData)) {
//       urlSearchParams.append(key, value);
//     }

//     // Make the POST request using Axios
//     const res = await api.post('/stored_email', urlSearchParams.toString(), {
//       headers: {
//         'Content-Type': 'application/x-www-form-urlencoded',
//       },
//     });

//     // Return the response data
//     if(res.data) {
//       const formDataForMail = {
//         candidate_email: formData.email,
//         company_id : formData.companyId,
//         recruiter_id : formData.recruiterId,
//         test_id: formData.testId,
//       };

//       console.log(formDataForMail)
//       const urlSearchParam = new URLSearchParams();
//       for (const [key, value] of Object.entries(formDataForMail)) {
//         urlSearchParam.append(key, value);
//       }

//       const response = await api.post('/send_assessment_confirmation', urlSearchParam.toString(), {
//         headers: {
//           'Content-Type': 'application/x-www-form-urlencoded',
//         },
//       });

//       console.log("successfully sent email", response)

//       return response;

//     }

//   } catch (error) {
//     // Handle errors
//     error.message = error.response && error.response.data.message;
//     throw error;
//   }
// };
export const StoreEmail = async (formData) => {
  try {
    const payload = {
      candidate_emails: formData.emails, // Now expects an array of emails
      company_id: formData.companyId,
      recruiter_id: formData.recruiterId,
      test_id: formData.testId,
    };
    
    console.log(
      "Payload being sent to /send_assessment_confirmation:",
      payload
    );
    
    const response = await api.post("/send_assessment_confirmation", payload, {
      headers: {
        "Content-Type": "application/json",
      },
    });
    
    if (response.data) {
      return response.data;
    } else {
      throw new Error("Response data is empty");
    }
  } catch (error) {
    console.error("Error in StoreEmail function:", error);
    
    // If it's an API error response, return the error data
    if (error.response && error.response.data) {
      return error.response.data;
    }
    
    throw error;
  }
};

export const sendTest = async (formData) => {
  try {
    const payload = {
      email: formData.email,
      test_id: formData.testId,
    };

    const response = await api.post("/send_test", payload);

    if (response.data) {
      if (response.data.message === "Test assigned successfully") {
        return { success: true, message: response.data.message };
      } else {
        return { success: false, message: response.data.message };
      }
    } else {
      throw new Error("Response data is empty");
    }
  } catch (error) {
    error.message = error.response && error.response.data.message;
    throw error;
  }
};

export const SendInviteAssement = async (formData) => {
  try {
    // Make the POST request to send assessment confirmation
    const formDataForMail = {
      candidate_email: formData.email,
      company_id: formData.companyId,
      recruiter_id: formData.recruiterId,
      test_id: formData.testId,
    };

    const urlSearchParamsMail = new URLSearchParams();
    for (const [key, value] of Object.entries(formDataForMail)) {
      urlSearchParamsMail.append(key, value);
    }

    const responseMail = await api.post(
      "/send_assessment_confirmation",
      urlSearchParamsMail.toString(),
      {
        headers: {
          "Content-Type": "application/x-www-form-urlencoded",
        },
      }
    );

    // Check if the response contains the user_id
    if (responseMail.data && responseMail.data.user_id) {
      // Return the response data along with the user_id
      return { ...responseMail.data };
    } else {
      throw new Error("User ID not found in response");
    }
  } catch (error) {
    // Handle errors
    error.message = error.response && error.response.data.message;
    throw error;
  }
};

{
  /* New Changes get_score [Start]*/
}
export const GetScore = async (testId, userId) => {
  try {
    const response = await api.post(`/get_score`, {
      user_id: userId,
      test_id: testId,
    });
    return response.data;
  } catch (error) {
    error.message = error.response && error.response.data.message;
    throw error;
  }
};
{
  /* New Changes get_score [End]*/
}

{
  /* New Changes Test Report [Start]*/
}
export const TestReport = async (testId, userId) => {
  try {
    const response = await api.post(`/v1/test_report`, {
      user_id: userId,
      test_id: testId,
    });
    return response.data;
  } catch (error) {
    error.message = error.response && error.response.data.message;
    throw error;
  }
};
{
  /* New Changes Test Score [End]*/
}

{
  /* New Changes Detailed Report [Start]*/
}
export const DetailedReport = async (testId, userId) => {
  try {
    const response = await api.post(`/v1/detailed_test_report`, {
      user_id: userId,
      test_id: testId,
    });
    return response.data;
  } catch (error) {
    error.message = error.response && error.response.data.message;
    throw error;
  }
};

// Company info details getCompanyInfodetails
export const getCompanyInfodetails = async (companyId) => {
  try {
    const response = await api.post(`/company_info`, {
      company_id: companyId,
    });
    return response.data;
  } catch (error) {
    error.message = error.response && error.response.data.message;
    throw error;
  }
};

// set apply candidates jobs
export const setCandidatesApplylist = async (ApplylistData) => {
  try {
    const response = await api.post(`/set_apply_candidate`, ApplylistData, {
      headers: { "Content-Type": "text/plain" },
    });
    return response.data;
  } catch (error) {
    error.message = error.response && error.response.data.message;
    throw error;
  }
};

// get shortlist jobs
export const getShortlistJobs = async (jobId) => {
  try {
    const response = await api.post(`/get_apply_candidate`, {
      job_id: jobId,
      // user_id:userId,
    });
    return response.data;
  } catch (error) {
    error.message = error.response && error.response.data.message;
    throw error;
  }
};

//getAllInfoRecruiterPage
export const getInfo = async (companyId) => {
  //export const getInfo = async (companyId) => {
  try {
    const response = await api.post(`/get_recruiter_job_details`, {
      company_id: 100,
      //recruiter_id: recruiterId,
    });
    return response.data;
  } catch (error) {
    error.message = error.response && error.response.data.message;
    throw error;
  }
};

//get applied candidates
export const getAppliedData = async (jobId) => {
  try {
    const response = await api.post(`/get_apply_candidate`, {
      job_id: jobId,
    });
    return response.data;
  } catch (error) {
    error.message = error.response && error.response.data.message;
    throw error;
  }
};

export const sendJobInvitation = async (jobId, candidateEmails) => {
  try {
    const response = await api.post(`/send_job_invitation`, {
      job_id: parseInt(jobId, 10),
      candidate_emails: candidateEmails,
    });
    return response.data;
  } catch (error) {
    error.message =
      (error.response && error.response.data && error.response.data.message) ||
      error.message;
    throw error;
  }
};

export const storeAppliedCandidate = async (jobId, userId) => {
  try {
    const response = await api.post(`/store_applied_candidate`, {
      job_id: String(jobId),
      user_id: String(userId),
    });
    return response.data;
  } catch (error) {
    error.message =
      (error.response && error.response.data && error.response.data.message) ||
      error.message;
    throw error;
  }
};

//get Feedback
export const getFeedback = async (jobId, feedbackType) => {
  if (feedbackType === "get feedback")
    try {
      const response = await api.post(`/get_set_feedback`, {
        job_id: jobId,
        feedback_type: feedbackType,
      });
      return response.data;
    } catch (error) {
      error.message = error.response && error.response.data.message;
      throw error;
    }
};

//set Feedback
export const setFeedback = async (jobId, feedbackType, userId, feedback) => {
  try {
    const response = await api.post(`/get_set_feedback`, {
      job_id: jobId,
      feedback_type: feedbackType,
      user_id: userId,
      feedback,
    });
    return response.data;
  } catch (error) {
    error.message = error.response && error.response.data.message;
    throw error;
  }
};

export const getInviteAndAttempt = async (testId) => {
  try {
    const response = await api.post(`/invite_test_count`, {
      test_id: testId,
    });
    return response.data;
  } catch (error) {
    error.message = error.response && error.response.data.message;
    throw error;
  }
};

export const FetchUserTestScore = async (testId) => {
  try {
    const response = await api.post(`/fetch_user_test_scores`, {
      // test_id: 953,
      test_id: testId,
    });
    return response.data;
  } catch (error) {
    error.message = error.response && error.response.data.message;
    throw error;
  }
};

export const setPassingCriteria = async (PassingPercentage, testId) => {
  try {
    const response = await api.post(`/set_passing_criteria`, {
      test_id: testId,
      passing_percentage: PassingPercentage,
    });
    return response.data;
  } catch (error) {
    error.message = error.response && error.response.data.message;
    throw error;
  }
};

export const getPassingCriteria = async (userId, testId) => {
  try {
    const response = await api.post(`/get_passing_criteria`, {
      test_id: testId,
      user_id: userId,
    });
    return response.data;
  } catch (error) {
    error.message = error.response && error.response.data.message;
    throw error;
  }
};

export const setImagePaths = async (testId, signature, companyLogo) => {
  try {
    const formData = new FormData();
    formData.append("test_id", testId);
    formData.append("signature", signature);
    formData.append("company_logo", companyLogo);

    const response = await api.post(`/set_image_paths`, formData, {
      headers: {
        "Content-Type": "multipart/form-data",
      },
    });

    return response.data;
  } catch (error) {
    error.message = error.response && error.response.data.message;
    throw error;
  }
};

export const generateCertificate = async (
  userId,
  testId,
  courseName,
  Designation,
  issuerName
) => {
  try {
    const response = await api.post(`/generate_certificate`, {
      user_id: userId,
      test_id: testId,
      course_name: courseName,
      designation: Designation,
      issuer_name: issuerName,
    });
    return response.data;
  } catch (error) {
    error.message = error.response && error.response.data.message;
    throw error;
  }
};

export const storeCertificateDetails = async (
  testId,
  courseName,
  designation,
  issuerName,
  passingPercentage
) => {
  try {
    const response = await api.post(`/store_certificate_details`, {
      test_id: testId,
      course_name: courseName,
      designation: designation,
      issuer_name: issuerName,
      passing_percentage: passingPercentage,
    });
    return response.data;
  } catch (error) {
    error.message = error.response && error.response.data.message;
    throw error;
  }
};

export const fetchCertificateDetailsByTest = async (testId) => {
  try {
    const response = await api.post(`/fetch_certificate_details_by_test`, {
      test_id: testId,
    });
    return response.data;
  } catch (error) {
    error.message = error.response && error.response.data.message;
    throw error;
  }
};

export const DownloadCertificate = async (userId, testId) => {
  try {
    const response = await api.get(
      `/v1/download_certificate/${userId}/${testId}/`,
      {
        responseType: "blob",
      }
    );
    console.log(response);

    // Create a Blob from the response data
    const blob = new Blob([response.data], { type: "application/pdf" });

    // Create a temporary link element to trigger the download
    const link = document.createElement("a");
    link.href = URL.createObjectURL(blob);
    link.download = "certificate.pdf"; // You can specify the desired filename
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);

    // Optionally, return some success indicator if needed
    return { success: true, message: "Certificate downloaded successfully" };
  } catch (error) {
    // Handle errors
    console.error("Error downloading certificate:", error.message);
    throw error; // You may choose to handle the error further or rethrow it
  }
};

export const ExpireTokenForAssessor = async (formData) => {
  try {
    // Request payload with only the required parameters
    const requestData = {
      email: formData.email,
      test_id: formData.test_id
      // No user_id since it's not required
    };
    
    // Log the final request data being sent
    console.log("Sending to API:", requestData);

    // Make the POST request to the correct endpoint
    const res = await api.post("/expire_token_for_assessor", requestData, {
      headers: {
        "Content-Type": "application/json",
      },
    });
    
    // Return the response data
    return res.data;
  } catch (error) {
    // Handle errors properly
    error.message = error.response && error.response.data.message;
    throw error;
  }
};

export const getcountJobByCompany = async (companyId) => {
  try {
    const response = await api.post(`/count_jobs_by_company`, {
      company_id: companyId,
    });
    return response.data;
  } catch (error) {
    error.message = error.response && error.response.data.message;
    throw error;
  }
};

// Function to get count of job-linked tests by company
export const getCountJobTestsByCompany = async (companyId) => {
  try {
    const response = await api.post(`/count_job_tests`, {
      company_id: companyId,
    });
    return response.data;
  } catch (error) {
    error.message = error.response && error.response.data.message;
    throw error;
  }
};
export const getCounterTrainingByCompany = async (companyId) => {
  try {
    const response = await api.post(`/createcounter_training`, {
      company_id: companyId,
    });
    return response.data;
  } catch (error) {
    error.message = error.response && error.response.data.message;
    throw error;
  }
};

// Function to get the training user counters by company
export const getTrainingUserCounterByCompany = async (companyId) => {
  try {
    const response = await api.post(`/training_user_counter`, {
      company_id: companyId,
    });
    return response.data;
  } catch (error) {
    error.message = error.response && error.response.data.message;
    throw error;
  }
};

// Function to get the count of tests with certificates by company
export const getCountTestsWithCertificateByCompany = async (companyId) => {
  try {
    const response = await api.post(`/count_tests_with_certificate`, {
      company_id: companyId,
    });
    return response.data;
  } catch (error) {
    error.message = error.response && error.response.data.message;
    throw error;
  }
};

// Function to get the count of users with tests that have certificates by company
export const getCountTestsWithCertificateUsersByCompany = async (companyId) => {
  try {
    const response = await api.post(`/count_tests_with_certificate_users`, {
      company_id: companyId,
    });
    return response.data;
  } catch (error) {
    error.message = error.response && error.response.data.message;
    throw error;
  }
};

export const getCountUsersByReferralCode = async (userId) => {
  try {
    const response = await api.post(`/count_users_by_referral_code`, {
      referral_code: userId,
    });
    return response.data;
  } catch (error) {
    error.message = error.response && error.response.data.message;
    throw error;
  }
};

export const getCountUsersByCompany = async (companyId) => {
  try {
    const response = await api.post(`/count_users_by_company`, {
      company_id: companyId,
    });
    return response.data;
  } catch (error) {
    error.message = error.response && error.response.data.message;
    throw error;
  }
};

export const getTotalShortlistCandidates = async (companyId) => {
  try {
    const response = await api.post(`/total_shortlist_candidates`, {
      company_id: companyId,
    });
    return response.data;
  } catch (error) {
    error.message = error.response && error.response.data.message;
    throw error;
  }
};

export const getTotalCandidatesByRecruiter = async (recruiterId) => {
  try {
    const response = await api.post(`/count_candidates_by_recruiter`, {
      recruiter_id: recruiterId,
    });
    return response.data;
  } catch (error) {
    error.message = error.response && error.response.data.message;
    throw error;
  }
};

export const getcountInvitedCandidates = async (companyId) => {
  try {
    const response = await api.post(`/count_invited_candidates`, {
      company_id: companyId,
    });
    return response.data;
  } catch (error) {
    error.message = error.response && error.response.data.message;
    throw error;
  }
};

export const getTotalUsers = async (recruiterId) => {
  try {
    const response = await api.get(`/get_total_users`, {
      recruiter_id: recruiterId,
    });
    return response.data;
  } catch (error) {
    error.message = error.response && error.response.data.message;
    throw error;
  }
};

export const getRecruiterJobCount = async (recruiterId) => {
  try {
    const response = await api.post(`/count_jobs_by_recruiter/`, {
      recruiter_id: recruiterId,
    });
    return response.data;
  } catch (error) {
    error.message = error.response && error.response.data.message;
    throw error;
  }
};

export const getRecruiterInvitedCandidates = async (recruiterId) => {
  try {
    const response = await api.post(`/count_invited_candidates_by_recruiter/`, {
      recruiter_id: recruiterId,
    });
    return response.data;
  } catch (error) {
    error.message = error.response && error.response.data.message;
    throw error;
  }
};

export const getCompanyRecruiters = async (companyId) => {
  try {
    const response = await api.post(`/get_company_recruiters`, {
      company_id: companyId,
    });
    return response.data;
  } catch (error) {
    error.message = error.response && error.response.data.message;
    throw error;
  }
};

export const getUsersByRecruiter = async (recruiterId) => {
  const rid = Number(recruiterId);
  try {
    const response = await api.post(`/get_users_by_recruiter`, {
      recruiter_id: rid,
    });
    return response.data;
  } catch (error) {
    error.message = error.response && error.response.data.message;
    throw error;
  }
};

export const getRecruiterUsersTodayReport = async (recruiterId) => {
  const rid = Number(recruiterId);
  try {
    const response = await api.post(`/recruiter_users_today_report`, {
      recruiter_id: rid,
    });
    return response.data;
  } catch (error) {
    error.message = error.response && error.response.data.message;
    throw error;
  }
};

export const getUserIdsForTest = async (testId) => {
  try {
    const response = await api.post("/get_user_ids_for_test", {
      test_id: testId,
    });

    return response.data.user_ids;
  } catch (error) {
    console.error("Error:", error.message);
    throw error;
  }
};

// export const AddedSkillsTrainingTest = async(testId,Skills)=> {
//   try {
//     const response = await api.post('/Added_skills_training_test', {
//       test_id: testId,
//       skills:Skills,
//     });

//     return response.data;
//   } catch (error) {
//     console.error('Error:', error.message);
//     throw error;
//   }
// }

export const InviteTrainingAssessment = async (testId, companyId, email) => {
  try {
    const response = await api.post("/invite_training_assessment", {
      candidate_email: email,
      test_id: testId,
      company_id: companyId,
    });

    return response.data;
  } catch (error) {
    console.error("Error:", error.message);
    throw error;
  }
};

{
  /* New Changes in invite_training_test [Ends] */
}

{
  /* New Changes in count_Test_company  [Starts] */
}
export const getcountTestCompany = async (companyId) => {
  try {
    const response = await api.post(`/count_tests_for_company/`, {
      company_id: companyId,
    });
    return response.data;
  } catch (error) {
    error.message = error.response && error.response.data.message;
    throw error;
  }
};
{
  /* New Changes in count_Test_company [Ends] */
}

{
  /* New Changes in count_tests_for_recruiter/  [Starts] */
}
export const getcountTestRecruiter = async (recruiterId) => {
  try {
    const response = await api.post(`/count_tests_for_recruiter/`, {
      recruiter_id: recruiterId,
    });
    return response.data;
  } catch (error) {
    error.message = error.response && error.response.data.message;
    throw error;
  }
};
{
  /* New Changes in count_tests_for_recruiter/ [Ends] */
}

{
  /* New Changes in phone scheduler meet [Start] */
}
export const SchedulerMeet = async (
  Title,
  Datetime,
  OrganiserEmail,
  AttendeeEmail
) => {
  try {
    const response = await api.post(`/schedule_meeting`, {
      title: Title,
      datetime: Datetime,
      organizer_email: OrganiserEmail,
      attendee_email: AttendeeEmail,
    });
    return response.data;
  } catch (error) {
    error.message = error.response && error.response.data.message;
    throw error;
  }
};

export const handleJobEmailAndDetails = async (
  candidateEmail,
  companyId,
  recruiterId,
  jobId,
  calendlyLink
) => {
  try {
    const response = await api.post(`/handle_job_email_and_details`, {
      candidate_email: candidateEmail,
      company_id: companyId,
      recruiter_id: recruiterId,
      job_id: jobId,
      calendly_link: calendlyLink,
    });
    return response.data;
  } catch (error) {
    error.message = error.response && error.response.data.message;
    throw error;
  }
};

export const DeleteTestApi = async (testId) => {
  try {
    const response = await api.post(`/delete_test_api/`, {
      test_id: testId,
    });
    return response.data;
  } catch (error) {
    // Extract error message from response if available
    const errorMessage = error.response?.data?.error || 
                         error.response?.data?.message || 
                         "Failed to delete test";
    
    // Preserve error structure but enhance message
    error.message = errorMessage;
    throw error;
  }
};

export const AutoAssignedUser = async (testId, companyId) => {
  try {
    const response = await api.post(`/invite_training_test`, {
      test_id: testId,
      company_id: companyId,
    });
    return response.data;
  } catch (error) {
    error.message = error.response && error.response.data.message;
    throw error;
  }
};

export const FileUploadVideo = async (File) => {
  try {
    const formData = new FormData();
    formData.append("file", File);
    const response = await api.post(`/file_upload_view`, formData, {
      headers: {
        "Content-Type": "multipart/form-data",
      },
    });
    return response.data;
  } catch (error) {
    error.message = error.response && error.response.data.message;
    throw error;
  }
};

export const PlayVideo = async (videoName) => {
  try {
    const formData = new FormData();
    formData.append("video_name", videoName);

    const response = await api.post("/play_video", formData, {
      headers: {
        "Content-Type": "multipart/form-data",
      },
    });

    const data = response?.data || {};
    return (
      data.video_url ||
      data.vidoo_url || // backend typo fallback
      data.url ||
      data.file_url ||
      data.video ||
      null
    );
  } catch (error) {
    // Handle errors
    throw error;
  }
};

export const SendVideo = async (email, videoName) => {
  try {
    const formData = new FormData();

    formData.append("video_name", videoName);
    formData.append("email", email);

    const response = await api.post(`/send_video`, formData, {
      headers: {
        "Content-Type": "multipart/form-data",
      },
    });
    return response.data;
  } catch (error) {
    error.message = error.response && error.response.data.message;
    throw error;
  }
};

export const SetTrainingId = async (companyId, recruiterId, trainingName) => {
  try {
    const response = await api.post(`/invite_training_test`, {
      company_id: companyId,
      training_name: trainingName,
      recruiter_id: recruiterId,
    });
    return response.data;
  } catch (error) {
    error.message = error.response && error.response.data.message;
    throw error;
  }
};

export const GetCourseForTraining = async (testId) => {
  try {
    const response = await api.post(`/get_course_for_training`, {
      test_id: testId,
    });
    return response.data;
  } catch (error) {
    error.message = error.response && error.response.data.message;
    throw error;
  }
};

export const SetCourseForTraining = async (trainingCreation) => {
  const {
    test_name,
    difficulty,
    proficiency,
    total_mcq_question,
    total_mri_question,
    total_fill_blanks_question,
    total_descriptive_question,
    total_coding_question,
    total_time,
    topics,
    easy_mcq_count,
    medium_mcq_count,
    hard_mcq_count,
    easy_mri_count,
    medium_mri_count,
    hard_mri_count,
    easy_fill_blanks_count,
    medium_fill_blanks_count,
    hard_fill_blanks_count,
    easy_descriptive_count,
    medium_descriptive_count,
    hard_descriptive_count,
    easy_coding_count,
    medium_coding_count,
    hard_coding_count,
    recruiter_id,
    company_id,
    test_subscription_type,
    image_folder_name,
    expiration_date,
    start_date,
    test_settings_created,
    skills,
    training_id,
    test_id,
  } = trainingCreation;
  try {
    const response = await api.post(`/set_course_for_training`, {
      test_name,
      difficulty,
      proficiency,
      total_mcq_question,
      total_mri_question,
      total_fill_blanks_question,
      total_descriptive_question,
      total_coding_question,
      total_time,
      topics,
      easy_mcq_count,
      medium_mcq_count,
      hard_mcq_count,
      easy_mri_count,
      medium_mri_count,
      hard_mri_count,
      easy_fill_blanks_count,
      medium_fill_blanks_count,
      hard_fill_blanks_count,
      easy_descriptive_count,
      medium_descriptive_count,
      hard_descriptive_count,
      easy_coding_count,
      medium_coding_count,
      hard_coding_count,
      recruiter_id,
      company_id,
      test_subscription_type,
      image_folder_name,
      expiration_date,
      start_date,
      test_settings_created,
      skills,
      training_id,
      test_id,
    });
    const responseOne = await api.post(`/get_course_for_training`, {
      test_id: response.data.test_id,
    });
    // return response.data;
    console.log(responseOne.data);
    return responseOne.data;

    //return response.data;
  } catch (error) {
    error.message = error.response && error.response.data.message;
    throw error;
  }
};

export const addCandidate = async (candidateData) => {
  try {
    const response = await api.post("/add_candidate", candidateData);
    return response.data;
  } catch (error) {
    error.message =
      (error.response &&
        error.response.data &&
        error.response.data.message) ||
      error.message;
    throw error;
  }
};

export const sendInvitations = async (emails, recruiterId, companyId) => {
  try {
    const payload = {
      emails: emails,
      recruiter_id: recruiterId,
      company_id: companyId,
    };

    const response = await api.post("/send_invitations", payload);

    if (response.data) {
      return response.data;
    } else {
      throw new Error("Response data is empty");
    }
  } catch (error) {
    error.message = error.response && error.response.data.message;
    throw error;
  }
};

export const autoDeleteExpiredInvites = async () => {
  try {
    const response = await api.post(`/auto_delete_expired_invites`);
    return response.data;
  } catch (error) {
    error.message = error.response?.data?.message || error.message;
    throw error;
  }
};

export const getCommunicationScores = async (userId, testId) => {
  try {
    const response = await api.post(`/get_communication_scores`, {
      user_id: userId,
      test_id: testId,
    });
    return response.data;
  } catch (error) {
    error.message = error.response && error.response.data.message;
    throw error;
  }
};
